import { BlackjackMainScene } from './blackjack-main-scene';
import { BlackjackApp } from '../blackjack-app';
import { GameBaseScene } from 'src/games/common/phaser/game/scenes/game-base-scene';
import { TranslocoService } from '@jsverse/transloco';

export class BlackjackPreloadScene extends GameBaseScene {
  public static get className(): string {
    return BlackjackPreloadScene.name;
  }

  constructor(
    private blackjackApp: BlackjackApp,
    private localAssetPath: string,
  ) {
    super(BlackjackPreloadScene.className);
  }

  public preloadTranslations(translocoService: TranslocoService): void {
    this.blackjackApp.preloadTranslations(translocoService);
  }

  public preload() {
    this.blackjackApp.preloadAssets(this, this.localAssetPath);
  }

  protected override onLoadProgress(progress: number) {
    super.onLoadProgress(progress);
  }

  protected override onLoadComplete() {
    super.onLoadComplete();

    this.scene.start(BlackjackMainScene.className);
  }
}
